export default {
  postCustomer: 'postCustomer',
  postAddress: 'postAddress',
};
